<template>
    <div class="main-container">
        <div class="head-container">
            <div class="form-label" v-if="userInfo.userType === 1">
                <span>所属商家：</span>
            </div>
            <div class="form-input" v-if="userInfo.userType === 1">
                <Select v-model="formParam.merchantId" filterable clearable>
                    <Option v-for="item in merchants" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
            </div>
            <div class="form-label">
                <span>名  称：</span>
            </div>
            <div class="form-input">
                <Input v-model="formParam.name"/>
            </div>
            <div class="form-button">
                <Button type="primary" icon="md-search" style="margin-right: 10px" @click="onQuery">查询</Button>
            </div>
        </div>
        <div class="button-container">
            <Button type="primary" icon="md-add" style="margin-right: 20px" @click="showModal">添加门店</Button>
        </div>
        <div class="table-container">
            <Table :columns="columns" :data="tableData">
                <template #action="{ row, index }">
                    <Button class="table-button-edit" size="small" style="margin-right: 5px" @click="edit(row)">编辑</Button>
                    <Poptip
                        confirm
                        title="该门店下所有的员工、会员都会删除，确定删除?"
                        @on-ok="remove(row)" placement="top-start" transfer>
                        <Button class="table-button-remove" size="small">删除</Button>
                    </Poptip>
                </template>
            </Table>
            <div style="margin-top: 10px;text-align: right">
                <Page v-model="formParam.current" :page-size="formParam.size"
                      :total="formParam.total"
                      @on-change="onPageChange"
                      @on-page-size-change="onPageSizeChange"
                      show-sizer show-elevator show-total/>
            </div>
        </div>
        <Modal
            v-model="modal"
            title="新增门店"
            footer-hide>
            <div>
                <Form :model="formItem" :label-width="80" ref="formItem" :rules="rules">
                    <FormItem label="门店名称" prop="name">
                        <Input v-model="formItem.name" placeholder="请输入门店名称"></Input>
                    </FormItem>
                    <FormItem label="所属商家" prop="merchantId" v-if="userInfo.userType === 1">
                        <Select v-model="formItem.merchantId" filterable>
                            <Option v-for="item in merchants" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="联系人" prop="contactsName">
                        <Input v-model="formItem.contactsName" placeholder="请输入联系人"></Input>
                    </FormItem>
                    <FormItem label="联系电话" prop="contactsPhone">
                        <Input v-model="formItem.contactsPhone" placeholder="请输入联系电话"></Input>
                    </FormItem>
                    <FormItem label="门店地址" prop="address">
                        <Input v-model="formItem.address" placeholder="请输入地址"></Input>
                    </FormItem>
                </Form>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleOk">确定</Button>
                    <Button @click="handleCancel">取消</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import {queryMerchantList, queryStore, removeStore, saveStore} from "@/api"

export default {
    name: "StoreManage",
    data() {
        return {
            formParam: {
                name: '',
                merchantId: '',
                total: 0,
                current: 1,
                size: 10,
            },
            formItem: {
                name: '',
                merchantId: '',
                contactsName: '',
                contactsPhone: '',
                address: '',
            },
            modal: false,
            loading: false,
            rules: {
                name: [
                    {required: true, message: '门店名称不能为空', trigger: 'blur'},
                ],
                merchantId: [
                    {required: true, message: '所属商家不能为空', trigger: 'change'},
                ],
                contactsName: [
                    {required: true, message: '联系人不能为空', trigger: 'blur'},
                ],
                contactsPhone: [
                    {required: true, message: '联系电话不能为空', trigger: 'blur'},
                ],
            },
            columns: [
                {
                    title: '门店名称',
                    key: 'name',
                    align: 'left',
                },
                {
                    title: '联系人',
                    key: 'contactsName',
                    align: 'center',
                    width: 100,
                },
                {
                    title: '联系电话',
                    key: 'contactsPhone',
                    align: 'center',
                    width: 150,
                },
                {
                    title: '地址',
                    key: 'address',
                    align: 'center',
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'center',
                    width: 180,
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 150,
                    align: 'center',
                },
            ],
            tableData: [],
            merchants: [],
            currentMerchant: '',
            userInfo: {},
        }
    },
    created() {
        this.userInfo = JSON.parse(sessionStorage.getItem('current-user'))
        this.queryMerchantList()
    },
    mounted() {
        this.onQuery()
    },
    methods: {
        async onQuery() {
            let res = await queryStore(this.formParam)
            if (res.data != null) {
                this.tableData = res.data
                this.formParam.current = res.current
                this.formParam.total = res.total
            }
        },
        async queryMerchantList() {
            let {data} = await queryMerchantList()
            this.merchants = data
            if (this.userInfo.userType === 2) {
                this.formParam.merchantId = this.merchants[0].id
                this.currentMerchant = this.merchants[0].id
            }
        },
        async showModal() {
            if (this.merchants === 0) {
                this.$Message.warning('您无法添加门店')
                return
            }
            this.formItem = {
                name: '',
                merchantId: '',
                contactsName: '',
                contactsPhone: '',
                address: '',
            }
            if (this.userInfo.userType === 2) {
                this.formItem.merchantId = this.currentMerchant
            }
            this.modal = true
        },
        handleOk() {
            this.loading = true
            this.$refs.formItem.validate(async (valid) => {
                if (valid) {
                    await saveStore(this.formItem)
                    this.loading = false
                    this.modal = false
                    this.onQuery()
                } else {
                    this.loading = false
                }
            })
        },
        handleCancel() {
            this.modal = false
        },
        edit(row) {
            this.formItem = Object.assign({}, row)
            this.formItem.merchantId = row.merchantId + ''
            this.modal = true
        },
        async remove(row) {
            if (row.isMain === 1) {
                this.$Message.warning({
                    background: true,
                    content: '无法删除总店',
                })
                return
            }
            await removeStore(row)
            await this.onQuery()
        },
        onPageChange(e) {
            this.formParam.current = e
            this.onQuery()
        },
        onPageSizeChange(e) {
            this.formParam.current = 1
            this.formParam.size = e
            this.onQuery()
        },
    },
}
</script>

<style scoped>
.form-label {
    display: inline-block;
    font-weight: bold;
    margin-left: 10px;
}

.form-input {
    display: inline-block;
    width: 400px;
    margin-right: 15px;
}

.head-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.button-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.form-button {
    display: inline-block;
}

.table-container {
    margin: 10px;
}
</style>
